module.exports = __webpack_public_path__ + "static/img/img-cp7.f809839.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp7.png
// module id = lMRd
// module chunks = 0